import * as React from "react";
import { findRestaurantInHref } from "../utils/restaurant";

// plugin imports

// utils imports

// svg imports

export const RouteContext = React.createContext({
	location: undefined,
});

const defaultValues = {
	restaurant: undefined,
};

export const LayoutContext = React.createContext(defaultValues);

export const LayoutProvider = ({ children }) => {
	const [restaurantId, setRestaurantId] = React.useState(undefined);
	const { location } = React.useContext(RouteContext);

	React.useEffect(() => {
		setRestaurantId(findRestaurantInHref(location?.href));
	}, [location]);

	return (
		<LayoutContext.Provider
			value={{
				...defaultValues,
				restaurantId,
				setRestaurantId,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
};
